import {MatchCashbackRequestModel} from "../../../../models/dashboard/marketplace/marketplaceCashbackRequestModel";
import {adminHttpClient} from "../../../../commons/adminHttpClinet";

const matchCashbackRequestTransaction = (model:MatchCashbackRequestModel): Promise<any> => {
    return adminHttpClient.put(`/api/Admin/AdminMarketplacePurchase/match-marketplace-cashback-request`, model)
}
export default matchCashbackRequestTransaction;